import './Main.scss';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Logger from '@KrashidBuilt/common/utils/logger';

import { Navigation } from '../../containers';

const logger = new Logger('Main');

/**
 * Main Component
 * @augments {Component<Props, State>}
 */
class Main extends Component {
    render() {
        logger.extra({ _: this });
        const { children } = this.props;
        return (
            <div className={'Main'}>
                <Navigation {...this.props} />
                <div className={'Content'}>
                    {children}
                </div>
            </div>
        );
    }
}

Main.defaultProps = {};

Main.propTypes = {
    children: PropTypes.shape().isRequired,
};

export default Main;